import { render, staticRenderFns } from "./OverlayUserDetailEdit.vue?vue&type=template&id=d7008806&"
import script from "./OverlayUserDetailEdit.vue?vue&type=script&lang=js&"
export * from "./OverlayUserDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7008806')) {
      api.createRecord('d7008806', component.options)
    } else {
      api.reload('d7008806', component.options)
    }
    module.hot.accept("./OverlayUserDetailEdit.vue?vue&type=template&id=d7008806&", function () {
      api.rerender('d7008806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayUserDetailEdit.vue"
export default component.exports